import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";
import { GlobalShell } from "~/components/GlobalShell";
import { SignInForm } from "~/app/(new)/(global)/sign-in/SignInForm";
import { isAuthed } from "~/utils/authGuard";

interface SignInSearch {
  redirect?: string;
  error?: string;
  /** invite link passed as `?i=` (already-authed accept flow) or `?invite=`. */
  i?: string;
  invite?: string;
}

export const Route = createFileRoute("/sign-in")({
  validateSearch: (search: Record<string, unknown>): SignInSearch => ({
    redirect: typeof search.redirect === "string" ? search.redirect : undefined,
    error: typeof search.error === "string" ? search.error : undefined,
    i: typeof search.i === "string" ? search.i : undefined,
    invite: typeof search.invite === "string" ? search.invite : undefined,
  }),
  beforeLoad: async ({ search }) => {
    // Invite-accept-while-authed is handled on the client after render.
    if (search.i) return;
    if (await isAuthed()) {
      throw redirect({ to: "/" });
    }
  },
  component: SignInPage,
});

function SignInPage() {
  // Load Google Identity Services (was next/script in the sign-in page).
  useEffect(() => {
    const SRC = "https://accounts.google.com/gsi/client";
    if (document.querySelector(`script[src="${SRC}"]`)) return;
    const script = document.createElement("script");
    script.src = SRC;
    script.async = true;
    document.head.appendChild(script);
  }, []);

  return (
    <GlobalShell>
      <SignInForm />
    </GlobalShell>
  );
}
